import { authenticatedRequest } from '@app/rest/rest.lib'

export interface IUpdatePasswordResponse {
  status: string
}

export function updatePassword(
  identifier: string,
  password: string,
  newPassword: string,
) {
  return authenticatedRequest<IUpdatePasswordResponse>({
    method: 'post',
    url: '/api/v1/account/changePassword',
    data: {
      identifier,
      password,
      newPassword,
    },
  })
}

export interface IRetrieveAccountInfoResponse {
  userId: string
  email: string
  givenName: string
  familyName: string
  role?: string
}

export function retrieveAccountInfo() {
  return authenticatedRequest<IRetrieveAccountInfoResponse>({
    method: 'get',
    url: '/api/v2/account',
  })
}

export interface VerifyPINResponse {
  status: boolean
}

export function verifyPIN(pin: string) {
  return authenticatedRequest<VerifyPINResponse>({
    method: 'POST',
    url: '/api/v2/account/pin',
    data: {
      pin,
    },
  })
}

export interface IClearPatientDataResponse {
  status: string
}

export function clearPatientData(passphrase: string, confirm: string) {
  return authenticatedRequest<IClearPatientDataResponse>({
    method: 'POST',
    url: `/api/v2/admin/clear/patient`,
    data: {
      passphrase,
      confirm,
    },
  })
}
